import { Component, OnInit } from '@angular/core';
import { CataloguesService } from '../catalogues.service';
import { ModulesService } from '../modules.service';
import { FeaturesService } from '../features.service';
import { MetaService } from '../meta.service';

@Component({
  selector: 'app-pricing',
  templateUrl: './pricing.component.html',
  styleUrls: ['./pricing.component.css']
})
export class PricingComponent implements OnInit {
  //properties
  modules: any[] = [];
  regs: any[] = [];
  features: any[] = [];

  //inject services
  constructor(private ms: ModulesService, private cs: CataloguesService, private mds: MetaService, private fs: FeaturesService) { }

  //retrieve data
  ngOnInit(): void {
    this.modules = this.ms.getModuleList();
    this.regs = this.cs.getCatalogList();
    this.features = this.fs.getFeatures();

    //SEO Optimization
    var strTitle = 'RegScale - Pricing';
    var description = 'RegScale pricing for all version of the platform';
    var keywords = 'RegScale, pricing, Community Edition (CE), Enterprise Edition (EE), managed services, capital purchasing';
    this.mds.updateTags(strTitle, keywords, description);
  }

  //sets the color
  setColor(strIcon: string): string {
    if (strIcon.indexOf('fa-check-circle') >= 0) {
      return 'color: green';
    } else if (strIcon.indexOf('fa-times-circle') >= 0) {
      return 'color: red';
    } else {
      console.log(strIcon + ': unknown icon.');
    }
  }

}
